export const getInitials = (name = "") => {
  if (!name) return "";
  const names = name.split(/\s+/);
  let first = "";
  let second = "";
  first = [...names[0]][0].toUpperCase();
  if (names.length > 1) {
    second = [...names[1]][0].toUpperCase();
  }
  return first + second;
};
